import Vue from 'vue'
import './plugins/vuetify'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import 'animate.css'
import moment from 'moment'
import VueMoment from 'vue-moment'
import VueApexChart from 'vue-apexcharts'

Vue.use(VueApexChart)
Vue.component('apexchart', VueApexChart)
Vue.use(VueMoment, {
  moment
})

Vue.moment.locale('pt-br')


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
